// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SRY_CnTrrLc2fZ3r_trE{width:100%;min-height:100vh;background:var(--bg)}.KaMsKMr7f2lrV4M4vWXg{display:block}.g9qT8_H0_tj2ZW882F9Q{display:none}@media(max-width: 480px){.KaMsKMr7f2lrV4M4vWXg{display:none}.g9qT8_H0_tj2ZW882F9Q{display:block}}`, "",{"version":3,"sources":["webpack://./src/features/timeline/Timeline.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,gBAAA,CACA,oBAAA,CAGF,sBACE,aAAA,CAGF,sBACE,YAAA,CAGF,yBACE,sBACE,YAAA,CAGF,sBACE,aAAA,CAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeline": `SRY_CnTrrLc2fZ3r_trE`,
	"desktop": `KaMsKMr7f2lrV4M4vWXg`,
	"mobile": `g9qT8_H0_tj2ZW882F9Q`
};
export default ___CSS_LOADER_EXPORT___;
